module.exports = __webpack_public_path__ + "img/V50.698bf119.jpg";